// trip-status-label.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tripStatusLabel'
})
export class TripStatusLabelPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'noShow':
        return 'No Show';
      case 'deboarded':
        return 'Deboarded';
      case 'noNeedEmail':
        return 'No Need - Email';
      case 'noNeedTelephone':
        return 'No Need - Telephone';
      case 'reschedule':
        return 'Reschedule';
      case 'noNeedInformed':
        return 'No Need - Late Informed';
      default:
        return value ? value.charAt(0).toUpperCase() + value.slice(1) : '---';
    }
  }
}